import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl, FormArray } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { environment } from '../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../components/mobile-header/mobile-header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ModalIntroComponent } from './modal-intro/modal-intro.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { getCookie } from '../../utils/getCookies';
import { ViewChild, ElementRef, HostListener } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { SidebarUserComponent } from "../../components/sidebar-user/sidebar-user.component";
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { skipFormValidation } from '../../utils/dev-flags';
import { FlowStepperComponent } from '../../components/flow-stepper/flow-stepper.component';
import { LanguageSwitcherComponent } from '../../components/language-switcher/language-switcher.component';


@Component({
  host: { class: 'conectio-brand' },
  selector: 'app-candidate-profiling',
  standalone: true,
  imports: [FlowStepperComponent, LanguageSwitcherComponent, CommonModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatRadioModule, ReactiveFormsModule, MatButtonModule,
    SidebarComponent, MobileHeaderComponent, FooterComponent, MatDialogModule, MatSliderModule, MatSelectModule, SidebarUserComponent, TranslateModule], 
  templateUrl: './candidate-profiling.component.html',
  styleUrl: './candidate-profiling.component.scss'
})
export class CandidateProfilingComponent {
  modalIntroVisible: boolean = false;
  currentCvFileUrl: any;
  descriptionForm: FormGroup;
  salaryForm : FormGroup;
  work_modality: string = '';
  // Currencies offered for the salary questions (EUR by default); sent to the API with the salaries
  readonly currencies = [
    { code: 'EUR', symbol: '€', flag: 'eu', name: 'Euro' },
    { code: 'USD', symbol: '$', flag: 'us', name: 'Dólar estadounidense' },
    { code: 'GBP', symbol: '£', flag: 'gb', name: 'Libra esterlina' },
    { code: 'CHF', symbol: 'CHF', flag: 'ch', name: 'Franco suizo' },
    { code: 'MXN', symbol: '$', flag: 'mx', name: 'Peso mexicano' },
    { code: 'BRL', symbol: 'R$', flag: 'br', name: 'Real brasileño' },
    { code: 'COP', symbol: '$', flag: 'co', name: 'Peso colombiano' },
    { code: 'ARS', symbol: '$', flag: 'ar', name: 'Peso argentino' },
    { code: 'CLP', symbol: '$', flag: 'cl', name: 'Peso chileno' },
  ];
  // Which amount field has its currency menu open (both fields share one currency)
  currencyMenu: 'fixed' | 'variable' | null = null;
  isLoading: boolean = false;
  errorMessage: string = '';
  selectedSectors: string[] = [];
  selectedFileName: string = '';
  tipoEmpresa: number = 0;
  selectedFile: any;
  step: number = parseInt(document.cookie.replace(/(?:(?:^|.*;\s*)current_step\s*\=\s*([^;]*).*$)|^.*$/, "$1")) || 5;
  manualStep: number | null = document.cookie.includes('manualStep') ? parseInt(document.cookie.replace(/(?:(?:^|.*;\s*)manualStep\s*\=\s*([^;]*).*$)|^.*$/, "$1")) || null : null;
  tipoEquipo: number = 0;
  loading: boolean = false;
  isRegistered: boolean = false;
  language: string = '';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(private fb: FormBuilder, private http: HttpClient, private router: Router, public dialog: MatDialog, private translate: TranslateService, private route: ActivatedRoute) {

    this.descriptionForm = this.fb.group({
      description: ['', Validators.required]
    });

    this.salaryForm = this.fb.group({
      salarioBruto: ['', [Validators.required, this.numberOnlyValidator]],
      salarioVariable: ['', [Validators.required, this.numberOnlyValidator]],
      currency: ['EUR'],
    });

    this.http.get(`${environment.url}/api/profiling`, { headers: { Authorization: `Bearer ${this.getCookie('access_token')}` } }).subscribe((response: any) => {
      if (response) {
        const data = response;
          if (data.sectors && Array.isArray(data.sectors)) {
            this.selectedSectors = data.sectors;
          }
          if (data.companyType) { 
            this.tipoEmpresa = data.companyType;
          }
          if (data.cv_file) {

            this.currentCvFileUrl = data.cv_file;
            // Given the path "public/job_offer_files\\361_Data_Analyst_Payments-_July_2025.pdf", extract only the file name.
            let filePath = this.currentCvFileUrl.replace(/^public[\\/]/, '').replace(/\\/g, '/');
            let fileName = filePath.split('/').pop();
            // Si el nombre del archivo empieza con un número seguido de un guion bajo, lo elimina
            fileName = fileName.replace(/^\d+_/, '');
            this.selectedFileName = fileName;
          }
          if (data.teamType) {
            this.tipoEquipo = data.teamType;
          }
          if (data.salarioBruto || data.salarioVariable) {
            this.salaryForm.patchValue({
              salarioBruto: data.salarioBruto,
              salarioVariable: data.salarioVariable
            });
          }
          if (data.currency) {
            this.salaryForm.patchValue({ currency: data.currency });
          }
          if (data.work_modality) {
            this.work_modality = data.work_modality;
          }
      }
    });

    this.route.queryParams.subscribe((params: any) => {
      if (params['is_registered']) {
        this.isRegistered = true;
      }
    });

    if (this.step === 5 && (this.manualStep === null || this.step === null)) {
        setTimeout(() => {
            this.dialog.open(ModalIntroComponent, { id: 'modal-intro', panelClass: 'conectio-brand' });
        }, 500);
    }

    this.language = this.translate.getCurrentLang() || this.translate.getFallbackLang() || 'es';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.language = event.lang;
      console.log(this.language);
    });



  }


  numberOnlyValidator(control: import("@angular/forms").AbstractControl) {
    const value = control.value;
    const isValid = /^[0-9]*$/.test(value);
    return isValid ? null : { numberOnly: true };
  }

  nextStep1(shouldContinue: boolean): void {

    if (this.salaryForm.valid || skipFormValidation) {
      this.loading = true;
      this.errorMessage = '';
      this.submitProfiling();
    } else {
      console.error('Salary form is invalid');
      this.errorMessage = this.translate.instant('candidateProfiling.completeProfile.errors.reviewSalaryForm');
      this.markAllAsTouched(this.descriptionForm);
      this.markAllAsTouched(this.salaryForm);
    }
  }

  /*
  submitProfiling(data: any, shouldContinue: boolean) {
    
      const headers = {
        headers: {
          Authorization: `Bearer ${this.getCookie('access_token')}`
        }
      };
      this.http.post(environment.url + '/api/profiling', data, headers).subscribe({
        next: (response: any) => {

          this.loading = false;
          if (shouldContinue) {
            console.log(response);
            this.step = this.step + 1;
            document.cookie = `current_step=${this.step}; path=/;`;
            
            if (this.manualStep != null) {
                this.manualStep++;
                document.cookie = `manualStep=${this.manualStep}; path=/`; // Save to cookie
            }

            if (this.step == 4) {
              document.cookie = `current_step=1; path=/;`;
              if (this.manualStep != null) {
                this.router.navigate(['/session/register/manual/validacion-linkedin']);
              } else {
                this.router.navigate(['/session/candidate-profiling-success']);
              }
            }
             window.scrollTo({
                top: 0,
                behavior: 'smooth' // Smooth scroll to the top
            });
          }
            
        },
        error: (error: any) => {
          console.error('Error:', error);
          this.loading = false;
          this.errorMessage = 'An error occurred while submitting the form.';
        }
      });

      /*
    } else {
      this.markAllAsTouched();
      console.error('Form is invalid');
      this.errorMessage = 'Revise el formulario';
    }*
  }
*/


  getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift(); 
    return null;  
  }

  goBack(isfirst: Boolean) {

    if (isfirst)
    {
      if (this.manualStep != null) {
        this.manualStep--;
        document.cookie = `manualStep=${this.manualStep}; path=/`; // Save to cookie
        this.router.navigate(['/session/register/manual']);
      }
      return;
    }
    if (this.manualStep != null) {
      this.manualStep--;
      this.step--;
      document.cookie = `manualStep=${this.manualStep}; path=/`; // Save to cookie
      document.cookie = `current_step=${this.step}; path=/`; // Save to cookie
    }
    else {
      this.step--;
      document.cookie = "current_step=" + this.step + "; path=/"; // Update step in cookie to be accessible from any page
    }
  }

  private markAllAsTouched(form: any) {
    Object.values(form.controls).forEach((control: any) => {
      if (control instanceof FormGroup) {
        Object.values(control.controls).forEach(innerControl => innerControl.markAsTouched());
      } else {
        control.markAsTouched();
      }
    });
  }


  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }


  onFileSelected(event: Event) {

    this.selectedFile = (event.target as HTMLInputElement).files![0];
    this.selectedFileName = this.selectedFile.name;

    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      // Logic to handle the file upload or display a preview
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.currentCvFileUrl = e.target.result;  // Preview the new image
      };
      reader.readAsDataURL(file);
    }
  }

  openFile() {
    if (this.currentCvFileUrl && this.selectedFile) {
      // If we have a selectedFile (File object), create a Blob URL and open it in a new tab
      const fileUrl = URL.createObjectURL(this.selectedFile);
      window.open(fileUrl, '_blank');
      // Optionally revokeObjectURL after some timeout for cleanup
      setTimeout(() => URL.revokeObjectURL(fileUrl), 10000); 
    }
    else {

      const url = environment.url + '/' + this.currentCvFileUrl;
      window.open(url, '_blank');
    }
  }

  deletefile() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.currentCvFileUrl = '';
  }

  submitProfiling(): void {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${this.getCookie('access_token')}`
      });

      const formData: FormData = new FormData();
      if (this.selectedFile) {
        formData.append('file', this.selectedFile, this.selectedFile.name);
      }
      formData.append('description', this.descriptionForm.value.description);
      formData.append('step', '1');
      formData.append('modalidad_trabajo', this.work_modality);
      formData.append('salarioBruto', this.salaryForm.value.salarioBruto);
      formData.append('salarioVariable', this.salaryForm.value.salarioVariable);
      formData.append('currency', this.salaryForm.value.currency || 'EUR');
      formData.append('language', this.language);
      formData.append('offer', this.getCookie('offer') || '');
      
      this.http.post<any>(`${environment.url}/api/v1/profiling`, formData, { headers })
        .subscribe({
          next: (response) => {
            this.step = this.step + 1;
            document.cookie = `current_step=${this.step}; path=/;`;
            this.router.navigate(['/session/candidate-profiling-success']);
          },
          error: (error) => {
            alert(`Error uploading file: ${error.error.error}`);
            console.error('Error uploading file', error);
          }
        });
  }

  // Salary amounts are typed as plain digits but shown with thousands dots (35000 -> 35.000)
  formatAmount(value: any): string {
    const digits = String(value ?? '').replace(/\D/g, '');
    return digits ? Number(digits).toLocaleString('de-DE') : '';
  }

  onAmountInput(controlName: 'salarioBruto' | 'salarioVariable', event: Event) {
    const input = event.target as HTMLInputElement;
    const digitsBeforeCaret = input.value.slice(0, input.selectionStart ?? input.value.length).replace(/\D/g, '').length;
    const digits = input.value.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
    this.salaryForm.get(controlName)?.setValue(digits);

    // Re-format and keep the caret after the same number of digits
    input.value = this.formatAmount(digits);
    let caret = 0;
    for (let seen = 0; caret < input.value.length && seen < digitsBeforeCaret; caret++) {
      if (/\d/.test(input.value[caret])) seen++;
    }
    input.setSelectionRange(caret, caret);
  }

  get fixedAmount(): number {
    return Number(String(this.salaryForm.get('salarioBruto')?.value ?? '').replace(/\D/g, '')) || 0;
  }

  get variableAmount(): number {
    return Number(String(this.salaryForm.get('salarioVariable')?.value ?? '').replace(/\D/g, '')) || 0;
  }

  get selectedCurrency() {
    const code = this.salaryForm.get('currency')?.value;
    return this.currencies.find(currency => currency.code === code) ?? this.currencies[0];
  }

  // Currency name in the active language (e.g. "US Dollar", "Dòlar dels Estats Units"); Spanish name as fallback
  private currencyNames: { [key: string]: Intl.DisplayNames | null } = {};
  currencyName(code: string, fallback: string): string {
    const lang = this.translate.getCurrentLang() || 'es';
    if (!(lang in this.currencyNames)) {
      try {
        this.currencyNames[lang] = new Intl.DisplayNames([lang], { type: 'currency' });
      } catch {
        this.currencyNames[lang] = null;
      }
    }
    const name = this.currencyNames[lang]?.of(code);
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : fallback;
  }

  toggleCurrencyMenu(field: 'fixed' | 'variable', event: Event) {
    event.stopPropagation();
    this.currencyMenu = this.currencyMenu === field ? null : field;
  }

  selectCurrency(code: string) {
    this.salaryForm.patchValue({ currency: code });
    this.currencyMenu = null;
  }

  // Close the currency menu on any click outside it, or with Escape
  @HostListener('document:click')
  @HostListener('document:keydown.escape')
  closeCurrencyMenu() {
    this.currencyMenu = null;
  }

  goToStep(step: number) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll to the top
    });
    
    if (step != 5 && this.manualStep) {
      document.cookie = `manualStep=${step}; path=/;`;

      this.router.navigate(['session/register/manual']);
    }

  }

}
